var version = {
    "name":      "dativery",
    "buildDateCode": "20260212-143157",
    "buildDate": "Thu Feb 12 2026 14:31:57 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260212-143157",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;